const theme = {
  token: {
    borderRadius: "8px",
    colorPrimary: "#6a0f0f",
    colorTextBase: "#1e1e1e",
    fontFamily: "DB Heavent Rounded",
    fontSize: 24,
    screenXS: 640,
    screenSM: 640,
    screenMD: 768,
    screenLG: 1024,
    screenXL: 1280,
    screenXXL: 1536,
    colorLink: "#1e1e1e",
    colorLinkActive: "#1d0c0c",
    colorLinkHover: "#6a0f0f",
  },
};

export { theme };
